'use client'

import { testIds } from '@/root/shared-consts'
import { ComponentProps, FC } from 'react'
import { Button } from '@/root/ui/tuuleliinid'
import { BottomArrowIcon } from '@/root/ui/shared'
import { Spinner } from '@/root/ui/shared/Spinner/Spinner'

interface NextButtonProps extends ComponentProps<typeof Button> {
  title: string
  subtitle: string
  loading?: boolean
}

export const NextButton: FC<NextButtonProps> = ({ title, subtitle, loading, ...buttonProps }) => {
  return (
    <Button
      variant="gray"
      className="flex h-20 w-1/2 max-w-64 items-center justify-between px-4"
      disabled={buttonProps.disabled}
      aria-busy={loading}
      onClick={buttonProps.onClick}
      data-testid={testIds.sailSelect.goToNext}
    >
      <div className="text-start">
        <div className="xxs:text-2xl text-xl leading-[1.2] uppercase">{title}</div>
        <div className="text-sm leading-[1.2]">{subtitle}</div>
      </div>
      <div className="mt-2.5 flex size-6 items-center justify-center">
        {loading ? (
          <Spinner className="size-4 border-2 border-white/40 border-t-white" />
        ) : (
          <BottomArrowIcon color="white" width={16} ignoreRtl className="ltr:-rotate-90" />
        )}
      </div>
    </Button>
  )
}
